// Conditions générales de vente et d'utilisation.
//
// Rédigées à partir de ce que le produit fait RÉELLEMENT — délai de
// rétractation, verrou inamovible, délai de retrait de 72 h, pari à
// 100 €. Un modèle générique aurait décrit un service qui n'existe pas, et
// c'est précisément ce qu'un client oppose en cas de litige.
//
// Le texte anglais est une traduction de commodité : le contrat reste
// soumis au droit français, comme le dit l'article 10.
import { Link } from 'react-router-dom'
import LegalShell from '../../components/urself/LegalShell'
import { COMPANY } from '../../lib/legal'
import { useT } from '../../lib/i18n'

export default function Cgv () {
  const L = useT().legal.cgv

  return (
    <LegalShell title={L.title} updated={L.updated} intro={L.intro}>
      <h2>{L.s1T}</h2>
      <p>{L.s1P}</p>

      <h2>{L.s2T}</h2>
      <p>{L.s2P}</p>

      <h2>{L.s3T}</h2>
      <p>{L.s3P}</p>
      <ul>
        {L.s3Items(COMPANY.removalDelayHours).map(x => <li key={x}>{x}</li>)}
      </ul>
      <p>{L.s3After}</p>

      <h2>{L.s4T}</h2>
      <p>{L.s4P}</p>

      <h3>{L.renewT}</h3>
      <p>{L.renewP}</p>

      <h2>{L.s5T}</h2>
      <p>{L.s5P}</p>
      <p>
        {L.s5P2a}
        <Link to="/remboursement">{L.s5Link}</Link>
        {L.s5P2b(COMPANY.refundDays)}
      </p>

      <h2>{L.s6T}</h2>
      <p>{L.s6P1}</p>
      <p>{L.s6P2}</p>

      <h2>{L.s7T}</h2>
      <p>{L.s7P}</p>

      <h2>{L.s8T}</h2>
      <p>{L.s8P}</p>

      <h2>{L.s9T}</h2>
      <p>{L.s9P}</p>

      <h2>{L.s10T}</h2>
      <p>
        {L.s10P1}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>.
      </p>
      <p>{L.s10P2}</p>
    </LegalShell>
  )
}
